var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rwd-form-field",class:_vm.colClasses},[_c('div',{staticClass:"mb-3"},[(_vm.hasLabel)?_c('label',{staticClass:"form-label",attrs:{"for":_vm.labelFor}},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]}),(_vm.required)?_c('span',{staticClass:"text-danger"},[_vm._v("*")]):_vm._e()],2):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }